import { render, staticRenderFns } from "./FragenIcon.vue?vue&type=template&id=4854ece4"
import script from "./FragenIcon.vue?vue&type=script&lang=js"
export * from "./FragenIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports